import {
  AccommodationStatus,
  AccommodationStatusWithDecisionByLoginNeeded,
} from 'src/store/placementDetailsPageSlice/types';
import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import {
  getPlacementDetails,
  setIsUpdateStatusModalOpen,
} from 'src/store/placementDetailsPageSlice/placementDetailsPageSlice';
import Input from '@amzn/meridian/input';
import LoadingSpinnerWrapper from 'src/components/shared/loadingSpinner/loadingSpinnerWrapper';
import { ModalFooter } from '@amzn/meridian/modal';
import PlacementDetailsService from 'src/services/placementDetailsService';
import React, { useState } from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { UpdateStatusProgress } from '../constants';
import { useAppDispatch, useAppSelector } from 'src/store/store';

interface DecisionByLoginEntryProps {
  selectedStatus: AccommodationStatus | AccommodationStatusWithDecisionByLoginNeeded;
  setProgress: (val: UpdateStatusProgress) => void;
}

// props isSiteParticipatingInDecisionHubPilot
const DecisionByLoginEntry = ({ selectedStatus, setProgress }: DecisionByLoginEntryProps) => {
  const dispatch = useAppDispatch();
  const { isSiteParticipatingInDecisionHubPilot, placementId } = useAppSelector((state) => state.placementDetailsPage);
  const { featureFlags } = useAppSelector((state) => state.user);

  const [decisionByLogin, setDecisionByLogin] = useState('');
  const [showSpinner, setShowSpinner] = useState(false);

  const decisionHubEnabled = featureFlags.DECISION_PORTAL && isSiteParticipatingInDecisionHubPilot;

  const onSave = async () => {
    setShowSpinner(true);
    try {
      const statusPayload = {
        accommodationId: placementId,
        accommodationStatusId: selectedStatus.id,
        decisionByLogin,
      };
      const updateStatusResponse = decisionHubEnabled
        ? await PlacementDetailsService.updateAccommodationStatusV2(statusPayload)
        : await PlacementDetailsService.updateAccommodationStatus(statusPayload);

      if (updateStatusResponse?.status === 200) {
        dispatch(getPlacementDetails(placementId));
        dispatch(setIsUpdateStatusModalOpen(false));
      }
    } finally {
      setShowSpinner(false);
    }
  };

  return (
    <>
      <Text id="update-placement-add-approver-text">Who has approved this placement?</Text>
      <LoadingSpinnerWrapper showSpinner={showSpinner}>
        <Row widths="fill" spacingInset={'400 none'}>
          <Column spacing="200">
            <Text tag="label" type="b200" color="primary">
              Decision Maker
            </Text>
            <Input
              id="update-placement-approver-input"
              data-cy="placement-status__approver_input"
              value={decisionByLogin}
              onChange={setDecisionByLogin}
              type="text"
              placeholder="Decision maker's alias..."
            />
          </Column>
        </Row>
      </LoadingSpinnerWrapper>
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fill">
          <Button
            id="update-placement-status-cancel-btn"
            data-cy="placement-status__cancel-btn"
            type="secondary"
            size="small"
            disabled={showSpinner}
            onClick={() => setProgress(UpdateStatusProgress.StatusSelection)}
          >
            Back
          </Button>
          <Button
            id="update-placement-status-save-btn-v2"
            data-cy="placement-status__save_radio-btn"
            type="primary"
            size="small"
            disabled={decisionByLogin.length === 0 || showSpinner}
            onClick={onSave}
          >
            Update Status
          </Button>
        </Row>
      </ModalFooter>
    </>
  );
};

export default DecisionByLoginEntry;
